const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
const QR_PREFIX = 'pirouette:ticket:';

export function extractTicketQrToken(input: unknown): string | null {
  if (typeof input !== 'string') return null;
  const raw = input.trim();
  if (!raw) return null;

  const prefixedIndex = raw.toLowerCase().indexOf(QR_PREFIX);
  if (prefixedIndex >= 0) {
    const token = UUID_RE.exec(raw.slice(prefixedIndex + QR_PREFIX.length))?.[0];
    return token ? token.toLowerCase() : null;
  }

  const token = UUID_RE.exec(raw)?.[0];
  return token ? token.toLowerCase() : null;
}

export function ticketQrPayload(token: string): string {
  return `${QR_PREFIX}${token}`;
}

export function redactQrToken(value: unknown): string {
  if (typeof value !== 'string') return '[invalid-token]';
  const token = extractTicketQrToken(value);
  if (!token) return '[invalid-token]';
  return `qr_${token.slice(0, 4)}…${token.slice(-4)}`;
}

export function redactQrTokensInText(text: string): string {
  return text.replace(UUID_RE, (token) => redactQrToken(token));
}
